
if (!customElements.get("iwt-carousel")) {
  class IWTCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideInner: ".m-iwt-carousel__wrapper"
      };

      this.classes = {
        grid: "m:display-grid",
        hidden: "m:hidden",
        swiper: "swiper-container",
        swiperWrapper: "swiper-wrapper"
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.slider = false;

      this.enableSlider = this.dataset.enableSlider === "true";
      this.autoplay = this.dataset.autoplay === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.autoplaySpeed = this.dataset.autoplaySpeed;

      this.defaultGap = parseInt(this.dataset.gap, 10) || 0;

      this.gaps = {
        desktop: this.defaultGap,
        tablet: this.defaultGap > 20 ? 20 : this.defaultGap
      };

      this.section = this.closest(".m-section");
      this.slideControls = this.section
        ? this.section.querySelector(".m-slider-controls")
        : null;

      this.init();

      this.handleMobileChange = () => {
        this.init();
      };

      document.addEventListener("matchMobile", this.handleMobileChange);
      document.addEventListener("unmatchMobile", this.handleMobileChange);
    }

    init() {
      if (!this.enableSlider) return;

      const { slideInner } = this.domNodes;

      if (!slideInner) return;

      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
        this.slider = false;
      }

      this.classList.add(this.classes.swiper);

      slideInner.classList.remove(this.classes.grid);
      slideInner.classList.add(this.classes.swiperWrapper);

      if (this.slideControls) {
        this.slideControls.classList.remove(this.classes.hidden);
      }

      this.initSlider();
    }

    initSlider() {
      const { slideInner } = this.domNodes;

      if (!slideInner || !this.slideControls) return;

      const nextEl = this.slideControls.querySelector(
        ".m-slider-controls__button-next"
      );

      const prevEl = this.slideControls.querySelector(
        ".m-slider-controls__button-prev"
      );

      const paginationEl = this.slideControls.querySelector(
        ".swiper-pagination"
      );

      this.options = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        spaceBetween: this.gaps.tablet,

        autoplay: this.autoplay
          ? {
              delay: (parseInt(this.autoplaySpeed, 10) || 5) * 1000,
              disableOnInteraction: false
            }
          : false,

        pagination: this.showPagination && paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
              renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
              }
            }
          : false,

        navigation: this.showNavigation && nextEl && prevEl
          ? {
              nextEl: nextEl,
              prevEl: prevEl
            }
          : false,

        breakpoints: {
          0: {
            slidesPerView: 1.2,
            slidesPerGroup: 1,
            spaceBetween: this.gaps.tablet
          },

          768: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: this.gaps.tablet
          },

          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: this.gaps.tablet
          },

          1280: {
            slidesPerView: 5,
            slidesPerGroup: 1,
            spaceBetween: this.gaps.desktop
          }
        }
      };

      this.slider = new MinimogLibs.Swiper(this, this.options);
    }

    destroySlider() {
      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
        this.slider = false;
      }

      const { slideInner } = this.domNodes;

      if (slideInner) {
        slideInner.classList.remove(this.classes.swiperWrapper);
        slideInner.classList.add(this.classes.grid);
      }

      this.classList.remove(this.classes.swiper);

      if (this.slideControls) {
        this.slideControls.classList.add(this.classes.hidden);
      }
    }

    disconnectedCallback() {
      document.removeEventListener(
        "matchMobile",
        this.handleMobileChange
      );

      document.removeEventListener(
        "unmatchMobile",
        this.handleMobileChange
      );

      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
        this.slider = false;
      }
    }
  }

  customElements.define("iwt-carousel", IWTCarousel);
}